import { Button } from '@design-system/components/button/button';
import { Input } from '@design-system/components/input/input';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { faDollar } from '@fortawesome/pro-regular-svg-icons';

export const PpcPriceModal = ({
  isOpen,
  close,
  enabled,
  requested,
  price,
}: {
  isOpen: boolean;
  close: () => void;
  enabled: boolean;
  requested: boolean;
  price: {
    monthly?: number;
    annual?: number;
  };
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={close}
      title="Exclusive"
      disableBackdropClick={true}
      modalClassName="w-full md:w-[742px]"
    >
      <>
        {requested ? (
          <div className="flex flex-col gap-6">
            <Typography variant="body" size="medium" className="font-normal">
              Review pending for exclusive model access
            </Typography>
            <Input
              startIcon={{ icon: faDollar }}
              label="Subscription price"
              disabled={true}
              value={'00.00 / monthly'}
              wrapperClassName="max-w-[200px]"
            />
            <Button
              color="neutral"
              className="w-[269px] self-center"
              onClick={close}
            >
              Ok, got it
            </Button>
          </div>
        ) : enabled ? (
          <div className="flex flex-col gap-6">
            <Typography variant="body" size="medium" className="font-normal">
              You have an exclusive subscription model. Here’s the price you’ve
              set for your content:
            </Typography>
            <div>
              {price?.monthly && (
                <Input
                  startIcon={{ icon: faDollar }}
                  label="Subscription price"
                  disabled={true}
                  value={`${price.monthly} / monthly`}
                  wrapperClassName="max-w-[200px]"
                />
              )}
              {price?.annual && (
                <Input
                  startIcon={{ icon: faDollar }}
                  label="Subscription price"
                  disabled={true}
                  value={`${price.annual} / yearly`}
                  wrapperClassName="max-w-[200px]"
                />
              )}
            </div>
            <Typography variant="body" size="medium">
              Since it's a beta feature all changes in price requires contact
              our support team at{' '}
              <a
                href={`mailto:creatorsupport@playbookapp.io `}
                className="text-black underline"
              >
                <b>creatorsupport@playbookapp.io</b>
              </a>
            </Typography>
            <Button
              color="neutral"
              className="w-[269px] self-center"
              onClick={close}
            >
              Ok, got it
            </Button>
          </div>
        ) : null}
      </>
    </Modal>
  );
};
